function valueIsComplex(value) {
    return typeof value !== 'string';
}
export function typedDictionary(obj, res = {}, prefix = '') {
    Object.keys(obj).forEach(x => {
        const value = obj[x];
        if (valueIsComplex(value)) {
            res[x] = {};
            typedDictionary(value, res[x], prefix ? `${prefix}.${x}` : x);
        }
        else {
            res[x] = prefix ? `${prefix}.${x}` : x;
        }
    });
    return res;
}
